import React, { useState } from "react";
import { getSkippedRefuelings } from "sources/books/refueling";

export default function FuelInfo(props) {
    const [skippedRefuelings, setSkippedRefuelings] = useState();
    const [loading, setLoading] = useState();

    if (!props.hasSkippedRefuelings) {
        return null;
    }

    const showSkippedRefuelings = () => {
        const openModal = (rest = {}) => {
            props.modal({
                name: "skippedRefuelings",
                windowMod: "route",
                mod: "skipped-refuelings",
                title: "Пропущенные заправки",
                skippedRefuelings,
                ...rest,
            });
        };
        if (!skippedRefuelings) {
            setLoading(true);
            getSkippedRefuelings(props.bidId).then((res) => {
                if (res) {
                    setSkippedRefuelings(res);
                    openModal({ skippedRefuelings: res });
                }
                setLoading(false);
            });
        } else {
            openModal();
        }
    };
    return (
        <div className={loading ? "loading loading--small" : ""}>
            <div className="inline-btn inline-btn--without-icon" onClick={showSkippedRefuelings}>
                Показать пропущенные заправки
            </div>
        </div>
    );
}
